import { usePostUploadTaxAccountantStatusFile } from "@/shared/api";
import { vars } from "@/shared/lib/theme.css";
import { FileModel } from "@/shared/model";
import { Button, Center, Column, ExcelInput, Toast, Typography } from "@/shared/ui";
import { standardSchemaValidator, useForm } from "@tanstack/react-form";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";

export const Route = createFileRoute("/(auth)/_layout/tax-accountant/registration-status")({
	component: TaxAccountantRegistrationStatus
});

const taxAccountantRegistrationStatusSchema = z.object({
	files: z.array(FileModel.model)
});

function TaxAccountantRegistrationStatus() {
	const { mutate, reset: resetReject } = usePostUploadTaxAccountantStatusFile();

	const form = useForm({
		defaultValues: {
			files: []
		},
		asyncAlways: true,
		validatorAdapter: standardSchemaValidator(),
		validators: { onChangeAsync: taxAccountantRegistrationStatusSchema, onChangeAsyncDebounceMs: 300 },
		onSubmit: async ({ value }) => {
			const fileIds = value.files.map(file => file.id);

			if (fileIds.length > 0) {
				mutate({ fileId: fileIds[0] }, {
					onSuccess: () => {
						Toast.info("세무사 등록, 말소 현황 등록되었습니다");
						setTimeout(() => {
							window.location.reload();
						}, 300);
					},
					onError: (error) => {
						Toast.error(`${error.message}`);
						resetReject();
					}
				});
			} else {
				Toast.error("파일을 올릴 수 없습니다");
			}
		}
	});

	return (
		<Column fullWidth style={{ gap: vars.size[32], paddingBottom: 200 }}>
			<Typography
				fullWidth
				size={vars.size[16]}
				fontWeight="normal"
				style={{ background: vars.color.gray[100], borderRadius: vars.size[8], padding: vars.size[16] }}
			>
				{"파일을 업로드 해주세요. 파일포맷은 xxx.xlsx 입니다."}
			</Typography>
			<form.Field
				name="files"
				children={(field) => (
					<ExcelInput
						initialValue={field.state.value || []}
						fileType={"TAX_ACCOUNTANT_STATUS"}
						onChange={(fileIds) => {
							const fileModel = fileIds.map((fileId) => ({ id: fileId, name: "", url: "" }));
							field.handleChange(fileModel);
						}}
					/>
				)}
			/>

			<Center fullWidth>
				<Button
					size="medium"
					type="submit"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						form.handleSubmit();
					}}
				>
					{"등록하기"}
				</Button>
			</Center>
		</Column>
	);
}
